import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

const notificationsAdapter = createEntityAdapter({})

const initialState = notificationsAdapter.getInitialState()

export const notificationApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getNotifications: builder.query({
            query: () => ({
                url: '/notifications',
                method: 'GET',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),

            transformResponse: responseData => {
                const loadedNotifications = responseData.map(notification => {
                    notification.id = notification._id
                    return notification
                });
                return notificationsAdapter.setAll(initialState, loadedNotifications)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Notification', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Notification', id }))
                    ]
                } else return [{ type: 'Notification', id: 'LIST' }]
            }
        }),

    }),
})

export const {
    useGetNotificationsQuery,
} = notificationApiSlice

// returns the query result object
export const selectNotificationsResult = notificationApiSlice.endpoints.getNotifications.select()

// creates memoized selector
const selectNotificationsData = createSelector(
    selectNotificationsResult,
    notificationsResult => notificationsResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllNotifications,
    selectById: selectNotificationById,
    selectIds: selectNotificationIds
    // Pass in a selector that returns the users slice of state
} = notificationsAdapter.getSelectors(state => selectNotificationsData(state) ?? initialState)